import React from 'react'
import Navbar from '../componenst/Navbar'
import { useState, useEffect } from 'react';
import '../PlayerCard.css';
import axios from 'axios';
import Compwinrate2 from '../componenst/Comprankkompetition/Compwinrate2';
import Compprofil from '../componenst/Comprankkompetition/Compprofil';
import Compfotopemain from '../componenst/Memberkarir/Compfotopemain';
import { Link } from 'react-router-dom';
export default function Rankingsolonew() {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [confetti, setConfetti] = useState([]);
    const [rank, setRank] = useState([]);

    const getdata = async () => {
        try {
            const response = await axios.get(urlapi + "Point_memberkarir?rank=true");
            setRank(response.data);
        } catch (error) { }
    };

    useEffect(() => {
        getdata();
        const colors = ['#00d4ff', '#f2d74e', '#ffffff', '#ff0055'];
        const newConfetti = Array.from({ length: 60 }).map((_, i) => ({
            id: i,
            left: Math.random() * 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            duration: Math.random() * 3 + 2,
            delay: Math.random() * 0.5,
            size: Math.random() * 10 + 5,
        }));

        setConfetti(newConfetti);
    }, []);
    return (
        <div style={{ minHeight: '100vh', borderRadius: '0px', }}>
            <Navbar judul="Ranking rank solo" aicon={true} />





            <div className="page-container">
                {/* Efek Kilat */}
                <div className="lightning-flash"></div>

                {/* Efek Pita */}
                {/* {confetti.map((piece) => (
                    <div
                        key={piece.id}
                        className="confetti"
                        style={{
                            left: `${piece.left}vw`,
                            backgroundColor: piece.color,
                            animationDuration: `${piece.duration}s`,
                            animationDelay: `${piece.delay}s`,
                            width: `${piece.size}px`,
                            height: `${piece.size * 1.5}px`,
                        }}
                    />
                ))} */}

                {/* Kartu Pemain */}
                <div className="container-fluid py-4">

                    <div className='d-flex justify-content-between'>
                        <Link to="/rankingsolonew" className="btn btn-secondary w-100">Klasement</Link>
                        <Link to='/topscoreranksolo' className="btn btn-outline-secondary w-100" style={{ marginLeft: '10px' }}>Top Scorers</Link>
                        <Link to='/topkiper' className="btn btn-outline-secondary w-100" style={{ marginLeft: '10px' }}>Top Kiper</Link>
                    </div>

                    <div className='text-white my-3'><i className='fas fa-user'></i> Klasement</div>

                    {/* g-2 memberikan jarak kecil antar kolom yang cocok untuk HP */}
                    <div className='row g-2 justify-content-center'>
                        {rank.map((data, index) => (
                            <div className="col-6 col-sm-6" key={data.id}>
                                <div className={index == 0 || index == 1 ? 'card-gold' : 'player-card'}>
                                    <div className="card-shine"></div>

                                    <div className="card-headersolo">
                                        <span className="rating">#{index + 1}</span>
                                        <span className="pos">RANK</span>
                                    </div>

                                    <div className="photo-container">
                                        {/* <Compprofil id_user={data.id_user} /> */}
                                        <Compfotopemain id_user={data.id_user} />
                                        {/* <img
                                            src={data.image}
                                            alt="Player"
                                            className="player-img-card"
                                        /> */}
                                    </div>

                                    <div className="card-content">
                                        <div className="name-wrapper">
                                            <span className="player-name">{data.nama}</span>
                                            <span className="potm-label">PLAYER RANK SOLO</span>
                                            <div className="name-divider"></div>
                                        </div>

                                        {/* Di layar HP, stats-grid mungkin butuh penyesuaian */}
                                        <div className="stats-grid">
                                            <StatItem val={data.play} lbl="PLY" />
                                            <StatItem val={data.win} lbl="WIN" />
                                            <StatItem val={data.draw} lbl="DRW" />
                                            <StatItem val={data.lost} lbl="LST" />
                                            {/* <StatItem val='10' lbl="GOL" /> */}
                                            <StatItem val={data.point} lbl="PNT" />
                                            {/* <StatItem val={<Compwinrate2 id_user={data.id_user} />} lbl="WRT" /> */}
                                        </div>

                                        <div className="logo-area" style={{ fontSize: '8px' }}>
                                            MEDAN MINI SOCCER
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div >
        </div >
    )
};

const StatItem = ({ val, lbl }) => (
    <div className="stat">
        <span className="val">{val}</span>
        <span className="lbl">{lbl}</span>
    </div>
);
